import unescapedText from 'I18n/utils/unescapedText';
export const getDefaultRatingOptions = () => [{
  text: unescapedText('marketplace-ui-reviews.list.filter.ALL'),
  value: 'ALL'
}, {
  text: unescapedText('marketplace-ui-reviews.list.filter.FIVE_STARS'),
  value: 5
}, {
  text: unescapedText('marketplace-ui-reviews.list.filter.FOUR_STARS'),
  value: 4
}, {
  text: unescapedText('marketplace-ui-reviews.list.filter.THREE_STARS'),
  value: 3
}, {
  text: unescapedText('marketplace-ui-reviews.list.filter.TWO_STARS'),
  value: 2
}, {
  text: unescapedText('marketplace-ui-reviews.list.filter.ONE_STAR'),
  value: 1
}];
export const getDefaultSortOptions = () => [{
  text: unescapedText('marketplace-ui-reviews.list.sort.NEWEST'),
  value: 'NEWEST'
}, {
  text: unescapedText('marketplace-ui-reviews.list.sort.OLDEST'),
  value: 'OLDEST'
}, {
  text: unescapedText('marketplace-ui-reviews.list.sort.HIGHEST'),
  value: 'HIGHEST'
}, {
  text: unescapedText('marketplace-ui-reviews.list.sort.LOWEST'),
  value: 'LOWEST'
}, {
  text: unescapedText('marketplace-ui-reviews.list.sort.MOST_HELPFUL'),
  value: 'MOST_HELPFUL'
}, {
  text: unescapedText('marketplace-ui-reviews.list.sort.RELEVANCE'),
  value: 'RELEVANCE'
}];